import request from '@/utils/request'

const companyPrefix = '/django_rest/company'
const clientAdmin = '/django_rest/client-admin'

export default {
  getCompanyReferralCashBalanceInfo (params) {
    return request.get(`${companyPrefix}/referral-cash/`, { params })
  },
  getCompanyReferralPointsBalanceInfo (params) {
    return request.get(`${companyPrefix}/referral-points/`, { params })
  },
  getClientAdminReferralCashBalance (params) {
    return request.get(`${clientAdmin}/referral-cash/`, { params })
  },
  getClientAdminReferralPointsBalance (params) {
    return request.get(`${clientAdmin}/referral-points/`, { params })
  },
  getCompanyRechargeList (params) {
    return request.get(`${companyPrefix}/${params.reward_type}/recharge/`, { params })
  },
  getClientAdminRechargeList (params) {
    return request.get(`${clientAdmin}/${params.reward_type}/recharge/`, { params })
  },
  updateCompanyRecharge (params) {
    return request.post(`${companyPrefix}/${params.reward_type}/recharge/`, params)
  },
  updateClientAdminRecharge (params) {
    return request.post(`${clientAdmin}/${params.reward_type}/recharge/`, params)
  }
}
